// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"1d704423","41":"1bb3226a","307":"2a7c62e9","377":"49b2af93"}[chunkId] + ".chunk.js";
};